// Opções do select de natureza jurídica do credor (#269).
//
// A lista e os rótulos vêm do domínio (`NATUREZA_JURIDICA_CREDOR` e
// `ROTULO_NATUREZA_JURIDICA`), que é a mesma lista do CHECK no banco. Aqui só se
// monta o formato do `SelectField`, para as três telas que cadastram credor não
// repetirem a lista — o cadastro de bancos e as duas telas de classificação de
// rubrica que criam consignatária na hora.

import { NATUREZA_JURIDICA_CREDOR, ROTULO_NATUREZA_JURIDICA } from "@atlas/domain";
import type { NaturezaJuridicaCredor } from "@atlas/sdk";

/** Rótulo de quem ainda não tem natureza: credor anterior a 08/10/2026. */
export const NATUREZA_A_DEFINIR = "A definir";

/**
 * As dez naturezas, precedidas da opção vazia. `vazio` é o texto dela: "A definir"
 * no cadastro de bancos (credor antigo sem valor) e um convite a escolher onde a
 * natureza é obrigatória.
 */
export function opcoesNaturezaJuridica(
  vazio: string,
): { value: NaturezaJuridicaCredor | ""; label: string }[] {
  return [
    { value: "", label: vazio },
    ...NATUREZA_JURIDICA_CREDOR.map((n) => ({ value: n, label: ROTULO_NATUREZA_JURIDICA[n] })),
  ];
}
